/* tslint:disable */

declare var Object: any;
export interface MenuAccessByContactRoleInterface {
  "Name": string;
  "Role_Name__c": string;
  "Menu_Name__c"?: string;
  "type"?: string;
  "isActive"?: boolean;
  "id"?: number;
}

export class MenuAccessByContactRole implements MenuAccessByContactRoleInterface {
  "Name": string;
  "Role_Name__c": string;
  "Menu_Name__c": string;
  "type": string;
  "isActive": boolean;
  "id": number;
  constructor(data?: MenuAccessByContactRoleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MenuAccessByContactRole`.
   */
  public static getModelName() {
    return "MenuAccessByContactRole";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MenuAccessByContactRole for dynamic purposes.
  **/
  public static factory(data: MenuAccessByContactRoleInterface): MenuAccessByContactRole{
    return new MenuAccessByContactRole(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MenuAccessByContactRole',
      plural: 'MenuAccessByContactRoles',
      path: 'MenuAccessByContactRoles',
      idName: 'id',
      properties: {
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Role_Name__c": {
          name: 'Role_Name__c',
          type: 'string'
        },
        "Menu_Name__c": {
          name: 'Menu_Name__c',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "isActive": {
          name: 'isActive',
          type: 'boolean',
          default: true
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
